import { render, staticRenderFns } from "./agentUpdateShangWei.vue?vue&type=template&id=53732923&scoped=true"
import script from "./agentUpdateShangWei.vue?vue&type=script&lang=js"
export * from "./agentUpdateShangWei.vue?vue&type=script&lang=js"
import style0 from "./agentUpdateShangWei.vue?vue&type=style&index=0&id=53732923&prod&scoped=true&lang=css"
import style1 from "./agentUpdateShangWei.vue?vue&type=style&index=1&id=53732923&prod&lang=css"
import style2 from "./agentUpdateShangWei.vue?vue&type=style&index=2&id=53732923&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53732923",
  null
  
)

export default component.exports